export default __webpack_public_path__ + "0c228be843b7c4e31ecb677409954bc6.svg";